import { MaybeRefOrGetter } from "vue";

const root = {
  type: "query",
  scope: "site",
} as const;

export const SiteQueryKeys = {
  root: () => [root] as const,
  site: (siteId: MaybeRefOrGetter<number>) => [...SiteQueryKeys.root(), { siteId }] as const,
  sections: (siteId: MaybeRefOrGetter<number>) => [...SiteQueryKeys.site(siteId), { scope: "sections" }] as const,
};
